import { useStrata } from '../../data/StrataProvider'
import { AthleteSetupForm } from './AthleteSetupForm'

export function Onboarding() {
  const { state, saveAthleteProfile } = useStrata()

  return (
    <main className="onboarding">
      <header>
        <span className="brand-mark">S</span>
        <span className="eyebrow">STRATA · CONFIGURACIÓN INICIAL</span>
        <h1>Tu plan.<br />Tus datos.</h1>
        <p>La rutina ya está cargada desde tu PDF. Completa tu punto de partida para que el seguimiento sea realmente tuyo.</p>
      </header>
      <AthleteSetupForm
        initialProfile={state.profile}
        initialWeight={75}
        submitLabel="Entrar a Strata"
        onSave={saveAthleteProfile}
        unit={state.preferences.unit}
      />
      <small className="local-note">Guardado localmente en este dispositivo.</small>
    </main>
  )
}
